// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./controllers";
import * as ActiveStorage from "@rails/activestorage";

ActiveStorage.start();

document.addEventListener("turbo:frame-missing", event => {
  // allow 429 page to break out of a turbo frame
  if (event.detail.response.status === 429) {
    event.preventDefault()
    event.detail.visit(event.detail.response)
  }
})


// useful to debug morphing/turbo streams
// window.addEventListener("turbo:render", (event) => {
//   console.log("Turbo render event:", event.detail.renderMethod, event);
// });
